import { styled } from 'linaria/react';
import { css } from 'linaria';

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--space-200);
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-100);
`;

export const LayerThickness = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-150);
  width: 100%;

  @media (--only-mobile) {
    gap: var(--space-100);
  }

  @media (max-width: 400px) {
    svg {
      width: 33px;
    }
  }
`;

export const AdditionalMaterialWrapper = styled.div`
  display: flex;
  margin-left: auto;
`;

export const SelectionGroupClassname = css`
  display: flex;
  flex-direction: column;
  gap: var(--space-100);

  @media (min-width: 768px) and (max-width: 1023px) {
    width: 65%;
  }

  @media (--only-tablet) {
    flex-direction: column;
  }
`;

export const SelectionGroupItemClassname = css`
  flex-grow: 1;
`;

export const LayerContainer = styled.div`
  @media (--only-tablet) {
    margin-top: var(--space-200);
    margin-bottom: var(--space-100);
    & > div {
      width: 100%;
    }
  }
`;
